export default __webpack_public_path__ + "images/5550e69a68e53d4d036116e739886818-radario_logo.svg";